"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidTokenWatcher = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var firebaseFailureCodes_1 = require("../../constants/firebaseFailureCodes");
var getCurrentTokenFromState_1 = require("../../state/getters/getCurrentTokenFromState");
var useFirebaseMessaging_1 = require("../../hooks/useFirebaseMessaging");
var sentrySdk_1 = require("../../sdks/sentry/sentrySdk");
var SentrySeverity_1 = require("../../sdks/sentry/SentrySeverity");
var timeConstants_1 = require("../../constants/timeConstants");
var analyticsEventBase_1 = require("../../sdks/firebase/analyticsEventBase");
var description = 'InvalidTokenWatcher';
var InvalidTokenWatcher = function () {
    var refreshToken = (0, useFirebaseMessaging_1.useFirebaseMessaging)({
        parentDescription: description,
    }).refreshToken;
    var invalidTokenCode = (0, react_redux_1.useSelector)(function (state) {
        var currentToken = (0, getCurrentTokenFromState_1.getCurrentNotificationTokenFromState)({ state: state });
        return currentToken === null || currentToken === void 0 ? void 0 : currentToken.invalidCode;
    });
    var isTokenStale = (0, react_redux_1.useSelector)(function (state) {
        var currentToken = (0, getCurrentTokenFromState_1.getCurrentNotificationTokenFromState)({ state: state });
        if (currentToken === null || currentToken === void 0 ? void 0 : currentToken.createdMs) {
            var msDifference = Date.now() - (currentToken === null || currentToken === void 0 ? void 0 : currentToken.createdMs);
            return msDifference / 1000 > timeConstants_1.SECONDS_IN_A_WEEK * 4;
        }
        return false;
    });
    (0, react_1.useEffect)(function () {
        if (isTokenStale) {
            (0, analyticsEventBase_1.analyticsEventBase)({ event: 'Stale messaging token' });
            refreshToken();
        }
    }, [isTokenStale]);
    (0, react_1.useEffect)(function () {
        var handle = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var matchErrorCodes, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        matchErrorCodes = invalidTokenCode ===
                            firebaseFailureCodes_1.firebaseFailureCodes.registrationTokenNotRegistered ||
                            invalidTokenCode === firebaseFailureCodes_1.firebaseFailureCodes.messagingMismatchedCredential;
                        if (!matchErrorCodes) return [3 /*break*/, 4];
                        (0, sentrySdk_1.sentrySdk)().captureMessage("".concat(description, " - ").concat(invalidTokenCode), SentrySeverity_1.SentrySeverity.Warning);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, refreshToken()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        (0, sentrySdk_1.sentrySdk)().captureMessage("".concat(description, " - ").concat(error_1), SentrySeverity_1.SentrySeverity.Warning);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        handle();
    }, [invalidTokenCode, refreshToken]);
    return null;
};
exports.InvalidTokenWatcher = InvalidTokenWatcher;
